import * as React from 'react'
import { Balloon,Icon } from '@alifd/next'

export default function DeliveryDay(props: { ladderPeriodList: any; quantity: any; moq: any; i18n: any; }) {
  const {ladderPeriodList, quantity, moq, i18n} = props;
  if ( !ladderPeriodList ) return null;
    let leadTime = '';
    // 未选择，默认moq
    if ( quantity === 0 ) {
      ladderPeriodList.forEach( (i: { maxQuantity: number; minQuantity: number; processPeriod: string; }) => {
        if ( i.maxQuantity >= moq && moq >= i.minQuantity ) {
          leadTime = i.processPeriod;
        }
      } )
    } else {
      ladderPeriodList.forEach( (i: { maxQuantity: number; minQuantity: number; processPeriod: string; }) => {
        if ( i.maxQuantity >= quantity && quantity >= i.minQuantity ) {
          leadTime = i.processPeriod;
        }
      } )
    }

    if ( !leadTime ) return null;

    return <div
      style={{
        textAlign: 'right',
      }}
    >
      {i18n['rightAction.leadtime']} <b>{leadTime}</b>{' '}
      {i18n['rightAction.days']} &nbsp;
      <Balloon
        trigger={<Icon type="prompt" size="small" />}
        align="br"
        alignEdge
        triggerType="hover"
        closable={false}
        style={{ width: 300 }}
      >
        {i18n['rightAction.leadtimetip'].replace( '[X]',leadTime )}
      </Balloon>
    </div>
}
